module.exports = __webpack_public_path__ + "static/img/1958_05_11_NYTimes_Preview_2.e9c4d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_05_11_NYTimes_Preview_2.jpg
// module id = DNlH
// module chunks = 0